module.exports = __webpack_public_path__ + "static/media/Vector-1.ac4527e4.svg";